export default __webpack_public_path__ + "static/media/apple-icon-72x72.b35577d5.png";